"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldError = FieldError;

var _compact2 = _interopRequireDefault(require("lodash/compact"));

var _fieldAlert = require("./field-alert");

var _formErrorsBasePathContext = require("./form-errors-base-path-context");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireWildcard(require("react"));

var _excluded = ["error", "hasIcon", "name", "type"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Get error paths.
 */
var getErrorPaths = function getErrorPaths(basePath, errorRule, field) {
  return (0, _compact2["default"])([basePath && field && errorRule ? "".concat(basePath, ".").concat(field, ".").concat(errorRule) : null, basePath && field ? "".concat(basePath, ".").concat(field, ".defaultError") : null, field && errorRule ? "defaultErrors.form.".concat(field, ".").concat(errorRule) : null, field ? "defaultErrors.form.".concat(field, ".defaultError") : null, basePath && errorRule ? "".concat(basePath, ".fallbacks.").concat(errorRule) : null, basePath ? "".concat(basePath, ".fallbacks.defaultError") : null, errorRule ? "defaultErrors.form.fallbacks.".concat(errorRule) : null, 'defaultErrors.form.fallbacks.defaultError']);
};
/**
 * Export `FieldError` component.
 */


function FieldError(props) {
  var _typeRef$current;

  var error = props.error,
      _props$hasIcon = props.hasIcon,
      hasIcon = _props$hasIcon === void 0 ? true : _props$hasIcon,
      name = props.name,
      _props$type = props.type,
      type = _props$type === void 0 ? 'error' : _props$type,
      rest = _objectWithoutProperties(props, _excluded);

  var _useTranslate = (0, _i18n.useTranslate)(),
      translate = _useTranslate.translate;

  var basePath = (0, _formErrorsBasePathContext.useFormErrorsBasePath)();
  var errorRef = (0, _react.useRef)(null);
  var typeRef = (0, _react.useRef)(null);

  if (error) {
    // Keep the current error on a ref so that it keeps being shown
    // while the collapse is closing.
    errorRef.current = translate(getErrorPaths(basePath, error.rule, name), error.args);
    typeRef.current = type;
  }

  return /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, _extends({}, rest, {
    hasIcon: hasIcon,
    type: (_typeRef$current = typeRef.current) !== null && _typeRef$current !== void 0 ? _typeRef$current : type
  }), errorRef.current);
}